import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cf1b9bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky top-0 z-1" }
const _hoisted_2 = { class: "center-right text--mini" }

import { onMounted, ref } from "vue"
import firebaseApp from "@/utilities/firebase/firebase"
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"
import LoginModal from "@/views/LoginModal.vue"
import { RouteNames } from "@/router"



export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavbar',
  setup(__props) {

const menu = ref([
	/*
	{
		label: "About",
		to: { name: RouteNames.About }
	},
	*/
	{
		label: "Profile",
		items: [
			{ label: "Settings", icon: "fas fa-cog", to: { name: RouteNames.Settings } },
			{ label: "Logout", icon: "fas fa-power-off", command: logout }
		],
		visible: () => isLoggedIn.value,
	},

	{
		label: "Recipes",
		items: [
			{ label: "Recipes List", icon: "fas fa-utensils", to: { name: RouteNames.Recipes } },
			{ label: "Tags", icon: "fas fa-tags", to: { name: RouteNames.RecipeTags } }
		],
		visible: () => isLoggedIn.value,
	},

	{
		label: "Feature Request",
		to: { name: "feature-request" },
		visible: () => isLoggedIn.value,
	},
	{
		key: "placeholder-login-key",
		label: "Login",
		command: () => changeLoginModalState(true),
		visible: () => !isLoggedIn.value,
	},
])



/* Lifecycle */
onMounted(async () => {
	const auth = getAuth(firebaseApp)

	onAuthStateChanged(auth, (user) => {

		// User is signed in
		if (user) {
			loggedInEmail.value = user.email ?? "no email"
			isLoggedIn.value = true
			console.log("logged in")
		} else {
			loggedInEmail.value = ""
			isLoggedIn.value = false
			console.log("logged out")
		}

		hasFullyLoaded.value = true
	})

	//This happens before the onAuthStateChanged
	//console.log("mounted")
})


/* Properties */
const isLoginModalOpen = ref(false)
const loggedInEmail = ref("")
const isLoggedIn = ref(false)
const hasFullyLoaded = ref(false)


/* Methods */
function changeLoginModalState(isOpening: boolean) {
	isLoginModalOpen.value = isOpening
}

function logout() {
	const auth = getAuth()

	signOut(auth).then(() => {
		console.log("Successfully signed out")
	}).catch((error) => {
		console.error(error)
		console.error("Error signing out")
	})
}


return (_ctx: any,_cache: any) => {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_p_menubar = _resolveComponent("p-menubar")!
  const _component_p_progress_bar = _resolveComponent("p-progress-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_p_menubar, { model: menu.value }, _createSlots({
        start: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_p_button, { class: "p-button-text p-button-text mr-4 home-button" }, {
                default: _withCtx(() => [
                  _createTextVNode("Airidas.net")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (!hasFullyLoaded.value)
          ? {
              name: "item",
              fn: _withCtx(() => []),
              key: "0"
            }
          : undefined,
        (isLoggedIn.value)
          ? {
              name: "end",
              fn: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, "Logged in as: " + _toDisplayString(loggedInEmail.value), 1)
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["model"]),
      (!hasFullyLoaded.value)
        ? (_openBlock(), _createBlock(_component_p_progress_bar, {
            key: 0,
            mode: "indeterminate"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(LoginModal, {
      "is-open": isLoginModalOpen.value,
      onChangeOpenState: changeLoginModalState
    }, null, 8, ["is-open"])
  ], 64))
}
}

})